module.exports = __webpack_public_path__ + "static/media/majorE2.d07bee4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE2.wav
// module id = tso0
// module chunks = 0